export enum UniversalMediaListSegmentType {
  MEDIA_DOMAIN = 'mediadomain',
  MEDIA_ID = 'mediaid',
  PUB_ID = 'pubid'
}

export enum UniversalMediaListSegmentTypeDisplayName {
  MEDIA_DOMAIN = 'App Bundles or Site Domains',
  MEDIA_ID = 'App IDs or Site IDs',
  PUB_ID = 'Publisher IDs'
}

export enum UniversalMediaListType {
  SHARED = 'shared',
  CURATED_MARKETPLACE = 'curated_marketplace',
  INTERNAL = 'internal'
}

export enum UniversalMediaListTypeDisplayName {
  SHARED = 'Shared',
  CURATED_MARKETPLACE = 'Curated Marketplace',
  INTERNAL = 'Internal'
}
